import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import MptUsersStatsWidget from "./Widgets/Users";
import MptCardsStatsWidget from "./Widgets/Cards";

import './stats.css'

class MptStats extends React.Component {
    render() {
        return (
            <div id="MptStats">
                <header className="content-header">
                    <h1>
                        Statistics
                        <small>dashboard</small>
                    </h1>
                    <ol className="breadcrumb">
                        {/*<li><i className="fa fa-trophy"/> MPP</li>*/}
                        <li className="text-bold"><Link to="/mpt/stats">Statistics</Link></li>
                    </ol>
                </header>
                <section className="content">
                    <div className="row">
                        <div id="players-list-widget" className="row">
                            <div className="col-md-12">
                                <MptUsersStatsWidget />
                            </div>
                            <div className="col-md-6">
                                <MptCardsStatsWidget />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default connect(
    state => ({ state }),
    dispatch => ({ dispatch }),
)(MptStats);



// WEBPACK FOOTER //
// ./src/pages/MPT/Stats/index.js